import { Button } from "antd";
import { useGetData } from "../../../../Network/useGetQueryData";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { usePostData } from "../../../../Network/usePostData";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { usePutData } from "../../../../Network/usePutData";
import { useSelector } from "react-redux";
import { UserRolesId } from "../../../enum";

export const PricesStep = ({
  onChangeStep,
  setFormData,
  formData,
}: {
  onChangeStep?: (step: number) => void;
  setFormData: (data: any) => void;
  formData?: any;
}) => {
  const userInfo = useSelector((state: any) => state.user.user);
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>();
  const [goNext, setGoNext] = useState<boolean>();
  const [selectedPlan, setSelectedPlan] = useState<number>();
  const { t, i18n } = useTranslation();
  const { mutateAsync } = usePostData({
    url: "sponsor",
    options: {
      onSuccess: () => {
        if (goNext) {
          onChangeStep(1);
        } else navigate("/companies");
      },
      onError: (error) => {},
    },
  });

  const { mutate } = usePutData<{ message: string }, { name: string }>({
    url: "sponsor",
    options: {
      onSuccess: (data) => {
        if (goNext) {
          onChangeStep(2);
        } else navigate("/companies");
      },
      onError: (error) => {},
    },
  });

  const handleAddSponsor = async () => {
    setLoading(true);

    try {
      const providerData = {
        ...formData,
        membershipPlanId: selectedPlan || formData?.membershipPlanId,
      };

      if (id) mutate({ ...providerData, id: +id });
      else {
        const response = await mutateAsync(providerData); //@ts-ignore
        navigate(`/add-company/${response?.data?.id}`);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const { data: membershipPlan } = useGetData<{
    data: any;
  }>({
    queryKey: ["company-plan"],
    url: `membership-plan?offset=0&limit=50&withDeleted=false`,
  });

  return (
    <>
      <div className="plans-cards-wrapper">
        {membershipPlan?.data?.items?.map((plan) => {
          if (
            userInfo.roleId === UserRolesId.Sponsor &&
            formData?.membershipPlanId !== plan?.id
          )
            return null;

          return (
            <div
              className={`plan-card ${selectedPlan === plan?.id || (formData?.membershipPlanId === plan?.id && !selectedPlan && userInfo.roleId === UserRolesId.Admin) ? "active" : ""}`}
              onClick={() =>
                userInfo.roleId === UserRolesId.Admin &&
                setSelectedPlan(plan?.id)
              }
            >
              <img src={plan?.icon} alt="Icon" />

              <div className="plan-title-price">
                <h3 style={{ color: plan?.colors?.backgroundEndColor }}>
                  {plan?.name?.[i18n.language || "en"]}
                </h3>
              </div>
              <p>{plan?.details?.[i18n.language || "en"]}</p>
            </div>
          );
        })}
      </div>

      <Button
        loading={loading}
        type="primary"
        style={{ marginRight: "8px" }}
        onClick={async () => {
          try {
            setGoNext(true);
            await handleAddSponsor();
          } catch (error) {}
        }}
      >
        {t("form.next")}
      </Button>
      <Button onClick={handleAddSponsor} loading={loading} type="link">
        {t("form.saveAndClose")}
      </Button>
    </>
  );
};
